import { render } from "./calendario_instalaciones.vue?vue&type=template&id=06621816&lang=es"
import script from "./calendario_instalaciones.vue?vue&type=script&lang=js"
export * from "./calendario_instalaciones.vue?vue&type=script&lang=js"

import "./calendario_instalaciones.vue?vue&type=style&index=0&id=06621816&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__